import { Outlet } from 'react-router';

import Copyright from '@/ui/login/Copyright';

export default function LoginWrapper() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <div className="mb-6 flex flex-col gap-2">
              <img className="size-14" src="/favicon.svg" />
              <p className="text-muted-foreground text-sm text-balance">
                Manage your in-store digital marketing network.
              </p>
            </div>
            <Outlet />
          </div>
        </div>
        <div className="mx-auto">
          <Copyright />
        </div>
      </div>
      <div className="relative hidden lg:block">
        <video
          autoPlay
          className="absolute inset-0 size-full object-cover"
          loop
          muted
          src="/gradient-animation.mp4"
        />
        <img
          alt="GTV logo"
          className="absolute top-1/2 left-1/2 size-96 -translate-x-1/2 -translate-y-1/2 transform"
          src="/gtv-logo-white.svg"
        />
      </div>
    </div>
  );
}
